"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.travellerFactory = travellerFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
/**
 * format traveller response
 * @param {MyAccount.RawTraveller} traveller
 * @returns {MyAccount.Traveller}
 */
function travellerFactory(traveller) {
  return {
    id: (0, _get2.default)(traveller, '_id'),
    firstName: (0, _get2.default)(traveller, 'FirstName'),
    middleName: (0, _get2.default)(traveller, 'MiddleName'),
    lastName: (0, _get2.default)(traveller, 'LastName'),
    title: (0, _get2.default)(traveller, 'Title'),
    birthDate: (0, _get2.default)(traveller, 'BirthDate'),
    idExpiryDate: (0, _get2.default)(traveller, 'IdExpiryDate'),
    type: (0, _get2.default)(traveller, 'Type'),
    idCountryId: (0, _get2.default)(traveller, 'IdCountryId'),
    countryId: (0, _get2.default)(traveller, 'CountryId'),
    idType: (0, _get2.default)(traveller, 'IdType'),
    idNumber: (0, _get2.default)(traveller, 'IdNumber'),
    userId: (0, _get2.default)(traveller, 'userId'),
    isActive: (0, _get2.default)(traveller, 'isActive'),
    isDuplicate: (0, _get2.default)(traveller, 'isDuplicate'),
    updatedAt: (0, _get2.default)(traveller, 'updated_at'),
    createdAt: (0, _get2.default)(traveller, 'created_at')
  };
}